import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import Icon from '../../../../../Icon';
import PrivacyIcon from '../../../../../PrivacyIcon';
import { formatDate } from '../../../../utils';
import styles from '../index.styl';

const SocialHistoryCard = ({ entity }) => {
  const { description, startDate, stopDate, isPrivate } = entity;
  const safeDate = stopDate || startDate;
  return (
    <div className={styles.root}>
      <div className={styles.header}>
        <div className={styles.leftSideWrapper}>
          <Icon
            size={28}
            name="icon-social-history-black"
            className={styles.iconType}
          />
          <div className={styles.contentWrapper}>
            <div className={styles.title}>
              <div
                className={cn(styles.titleWrapper, {
                  [styles.noTitle]: !description,
                })}
              >
                {description}
              </div>
              <PrivacyIcon show={isPrivate} className={styles.privacyIcon} />
            </div>
            <div className={styles.description}>
              {safeDate ? formatDate(safeDate, 'MMM D, Y') : ''}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

SocialHistoryCard.propTypes = {
  entity: PropTypes.object,
};

export default SocialHistoryCard;



// WEBPACK FOOTER //
// ./src/components/PatientHealthboard/PatientPortal/DataList/Card/SocialHistoryCard/index.jsx